import {addEditCountryActionTypes} from "../constants/AddEditActionConstants";
import authService from "../../../auth/AuthService";

const editSelectedCountry = (countryDetail) => ({
    type: addEditCountryActionTypes.EDIT_ONE_COUNTRY,
    payload: {countryDetail}
});
const selectCountry = (country) => ({
    type: addEditCountryActionTypes.SET_COUNTRY,
    payload: {country}
});
const selectDropdowns = (option, change_obj) => ({
   type: addEditCountryActionTypes.SET_COUNTRY_DROPDOWNS,
   payload: {option, change_obj}
});
const toggleProductSupport = (product_type) => ({
    type: addEditCountryActionTypes.SET_COUNTRY_PRODUCT_SUPPORT,
    payload: {product_type}
});
const updateMatchRates = ({name, value}) => ({
    type: addEditCountryActionTypes.SET_MATCH_RATES,
    payload: {name, value}
});
const toggleModal = () => ({
    type:addEditCountryActionTypes.TOGGLE_MODAL
});
const addCountryModal = () => ({
    type: addEditCountryActionTypes.ADD_COUNTRY
});
const validateCountry = (countryObj, notesObj, authToken) => ({
    type: addEditCountryActionTypes.VALIDATE_COUNTRY_FORM,
    payload: {countryObj, notesObj, authToken}
});
const updateCountry = () => ({
    type: addEditCountryActionTypes.UPDATED_COUNTRY_REFRESH
});

const updateNotesForCountry = ({name, value}) => ({
    type: "UPDATE_NOTES",
    payload: {name, value}
});

export function editOneCountry(countryDetail) {
    return (dispatch) => {
        dispatch(editSelectedCountry(countryDetail));
    }
}

export function setCountry(country) {
    return (dispatch) => {
        dispatch(selectCountry(country));
    }
}

export function setCountryDropdowns(option, change_obj) {
    return (dispatch) => {
        dispatch(selectDropdowns(option, change_obj));
    }
}

export function setProductSupport(product_type) {
    return (dispatch) => {
        dispatch(toggleProductSupport(product_type));
    }
}

export function setMatchRates({name, value}) {
    return (dispatch) => {
        dispatch(updateMatchRates({name, value}));
    }
}

export function toggleCountryModal() {
    return (dispatch) => {
        dispatch(toggleModal());
    }
}

export function addCountry() {
    return (dispatch) => {
        dispatch(addCountryModal());
    }
}

export function updatedCountryRefresh() {
    return (dispatch) => {
        dispatch(updateCountry());
    }
}

export function validateCountryForm(countryObj, notesObj){
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(validateCountry(countryObj, notesObj, authToken));
    }
}

export function updateNotesFieldForCountry({name, value}) {
    return (dispatch) => {
        dispatch(updateNotesForCountry({name, value}))
    }
}